.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2px 2px 2px 2px;
  color: var(--chart-302-icon-buttons-titles);
  border-top: 1px solid var(--blue-layout-400-primary);

  gz-text {
    line-height: 15px;
    font-weight: 500;
    width: fit-content;
    font-family: 'Montserrat Medium', 'Montserrat', sans-serif;
  }

  gz-icon {
    margin-right: 4px;
  }
}
